import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { list, stack } from '../../../../common/classes/request-builder';
import { RequestButtonTypes } from '../../../../common/components/request-button/request-button.component';
import { Utils } from '../../../../common/utils';
import { EntidadesApiService } from '../../../../service/api/entidades-api.service';
import { TransaccionesApiService } from '../../../../service/api/transacciones-api.service';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { Filtering } from '../../../../service/filtering/filtering';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import { BaseView } from '../../../../view/base-view';
import { environment } from '../../../../../environments/environment';
import { StorageManager } from '../../../../common/storage-manager.class';
import { fillTipoTransaccion } from './transacciones-form/tipo_transaccion';
import moment from 'moment';

import type { OnInit } from '@angular/core';
import { TransaccionModel } from 'src/app/models/reto/transaccion.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { UserModel } from 'src/app/models/usuarios/user.model';
import { EntidadModel } from 'src/app/models/reto/entidad.model';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';
import { DropdownData } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';

import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { TransaccionesFormDefinition } from './transacciones-form/form-control/form-definition';
import { TransaccionesGenerateFormDefinition } from './transacciones-form/form-control/generate-form-definition';


@Component({
    selector: 'app-transacciones',
    standalone: false,
    templateUrl: './transacciones.component.html',
    styleUrls: ['./transacciones.component.scss']
})
export class TransaccionesComponent extends BaseView<TransaccionModel> implements OnInit {
    public form: TransaccionesFormDefinition | null = null;


    public appName = environment.appName;
    public currentUser = StorageManager.getUser();
    public serverUrl = environment.serverUrl;
    public hasClients = environment.features.hasClients;
    public userCanSeeClientes = this.hasClients &&
    (environment.features.userCanSeeClientes ? true : (StorageManager.getUser().rol === 'admin'));
    public clienteName = environment.features.clienteName;
    public canGenFile: boolean = 
        this.appName !== 'ctl' ? 
            true : (StorageManager.getUser().nombre.includes('oberto') || 
      StorageManager.getUser().nombre.includes('ocatec')  ) ? true : false;

    public getRequest!: RequestHandler<TransaccionModel[]>;
    public deleteRequest!: RequestHandler<TransaccionModel>;
    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public menuItemId = 'reto-transacciones';
    public filter: Filtering<TransaccionModel> = new Filtering<TransaccionModel>();

    public ropo_responsable: DropdownData<string> = list();

    public generateForm = new TransaccionesGenerateFormDefinition(this.ropo_responsable);

    /* lista de años por defecto */
    public year = list();

    public deleteWarningMessage = '';
    public deleteWarning = '';

    public parcelasAux = null;


    public cols: ColInterface[] = [
        { field: 'fecha', header: 'Fecha ', width: '80px' },
        { field: 'tipo_transaccion', header: 'Tipo Transacción', filter: '' },
        { field: 'id_entidad_origen', header: 'Entidad Responsable', filter: '' },
        { field: 'ropo_origen', header: 'ROPO Responsable', filter: '', width: '120px' },
        { field: 'id_entidad_destino', header: 'Entidad Destino', filter: '', width: '150px' },
        { field: 'ropo_destino', header: 'ROPO Destino', filter: '', width: '120px' },
        { field: 'id_producto', header: 'Producto', filter: '', width: '150px' },

    ];

    public user: UserModel = StorageManager.getUser();
    public fecha_inicio: Date = new Date();
    public fecha_fin: Date = new Date();
    public modelGenFields = {
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
    } as TransaccionModel;

    public tipo_transaccion: DropdownData<string> = fillTipoTransaccion();

    private readonly generationDateFormats: string[] = [
        'YYYY-MM-DD',
        'DD/MM/YYYY',
        'D/M/YYYY',
        'DD-MM-YYYY',
        'D-M-YYYY',
    ];

    constructor(
        public transaccionesApi: TransaccionesApiService,
        public entidadesApi: EntidadesApiService,
        public dashboard: DashboardService,
        private router: Router
    ) {
        super(dashboard, transaccionesApi.TransaccionesGET, transaccionesApi.TransaccionesDELETE);
        this.getRequest = transaccionesApi.TransaccionesGET;
        this.deleteRequest = transaccionesApi.TransaccionesDELETE;
    }


    public ngOnInit(): void {
        this.dashboard.setSubmenuItem('reto', this.menuItemId);
        stack([

        ]).then(() => {

            this.filter.filter();
            return;
        }
        ).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );
        if (this.appName === 'innovia' && this.currentUser.rol === 'user'){
            const client = StorageManager.getClient()?.nombre;

            this.filter.addFilter((data: TreeNode<TransaccionModel>[] | void) => (data || [])
                .filter((it: TreeNode<TransaccionModel>) => it)
                .filter((it) => client === (it as TransaccionModel).entidad_origen_nombre)
            );
        }// if();

        this.loadRopoResponsables();
    // this.filter.addFilter(data => {
    //   return (data || []).filter(finca => finca && finca.id);
    // });
    }

    private loadRopoResponsables(): void {
        this.entidadesApi.EntidadesGET.toPromise()
            .then((entidades: EntidadModel[] | undefined) => {
                (entidades ?? []).forEach((entidad: EntidadModel) => {
                    this.addEntidadRopoOption(entidad.nombre, entidad.roposs);
                    this.addEntidadRopoOption(entidad.nombre, entidad.ropost);
                    this.addEntidadRopoOption(entidad.nombre, entidad.roposu);
                });

                return;
            })
            .catch((error: unknown) => {
                console.log('catch en EntidadesGET: ' + error);
            });
    }

    private addEntidadRopoOption(nombre: string, ropo: string | null | undefined): void {
        const normalizedRopo = ropo?.trim() ?? '';

        if (!normalizedRopo) {
            return;
        }

        const option = { label: nombre + ' - ' + normalizedRopo, value: normalizedRopo };

        this.ropo_responsable.filtered.push(option);
        this.ropo_responsable.values.push(option);
    }


    public add(): void {
        /*     if (!StorageManager.getClient() && this.userCanSeeClientes) {
      this.dashboard.openClientDialog();
    } else { */
        this.router.navigate(['dashboard', 'reto-crear-transacciones']);
        /*     } */
    }

    public edit(data: TransaccionModel): void {
        this.router.navigate(['dashboard', 'reto-editar-transacciones', data.id]);
    }

    public duplicate(data: TransaccionModel): void {
    
        this.router.navigate(['dashboard', 'reto-duplicar-transacciones', data.id]);
    }

    public override deleteRegister(): void {
        if (this.model.id) {
            if (this.deleteWarning) {
                this.deleteWarning = '';
                this.deleteWarningMessage = '';

                this.deleteRequest.safePerform(this.model);
                this.deleteRequest.response(() => {
                    if (!this.deleteRequest.hasError) {
                        this.getRequest.safePerform();
                    }
                });
            } else {
                this.deleteWarningMessage =
          'Se borrará toda la información asociada';
                this.deleteWarning = '¡Entidad con datos! ¿Continuar?';
            }
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }

    public globalConditionalStyle(
        _value: string, 
        _col: ColInterface, 
        _colGroup: ColInterface[], 
        row: TreeNode<TransaccionModel>
    ): ColStylesInterface {

        // if (Utils.isNumber(value) || col.field === 'telefono') {
        //   return {
        //     textAlign: 'center',
        //     marginRight: '60px'
        //   };
        // }
        // if (col.field === 'provincia') {
        //   return {
        //     textAlign: 'center'
        //   };
        // }
        const transaccion = row.data as TransaccionModel;

        transaccion.num_envases = Utils.decimalFormat(transaccion.num_envases + '', 2, '.', ',', 3);
        transaccion.capacidad_envase = Utils.decimalFormat(transaccion.capacidad_envase + '', 2, '.', ',', 3);
        transaccion.volumen_total = Utils.decimalFormat(transaccion.volumen_total + '', 2, '.', ',', 3);
        return {};
    }


    public globalVisualTransform(value: string): string {
        return value;  
    }


    public formChanges(model?: Partial<TransaccionModel>, changedField = ''): void {
        if (!model || changedField.startsWith('__')) {
            return;
        }

        this.patchGenerateModel(model);
    }

    public emptyDates(): void {
        this.fecha_inicio = new Date();
        this.fecha_fin = new Date();

        this.patchGenerateModel({
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
        });
    }

    private patchGenerateModel(model: Partial<TransaccionModel>): void {
        Object.assign(this.modelGenFields, model);
    }


    public generarArchivo(): void {
        const fechaInicio = this.formatGenerationDate(this.modelGenFields.fecha_inicio);
        const fechaFin = this.formatGenerationDate(this.modelGenFields.fecha_fin);
        const ropoResponsable = this.ropo_responsable.selected;

        if (!fechaInicio || !fechaFin || !ropoResponsable) {
            alert('Debe especificar todos los campos con fechas válidas.');
            return;
        }

        const retoFields = '?fecha_inicio=' + encodeURIComponent(fechaInicio) +
            '&fecha_fin=' + encodeURIComponent(fechaFin) +
            '&ropo_resposable=' + encodeURIComponent(ropoResponsable);

        window.open((this.serverUrl + 'ws/reto/getReto.php' + retoFields), '_blank');
    }

    private formatGenerationDate(value: unknown): string {
        if (value instanceof Date) {
            return moment(value).format('YYYY-MM-DD');
        }

        if (typeof value === 'string') {
            const normalizedValue = value.trim();

            if (!normalizedValue) {
                return '';
            }

            const parsedDate = moment(normalizedValue, this.generationDateFormats, true);

            if (parsedDate.isValid()) {
                return parsedDate.format('YYYY-MM-DD');
            }

            const fallbackDate = moment(normalizedValue);

            return fallbackDate.isValid() ? fallbackDate.format('YYYY-MM-DD') : '';
        }

        const parsedDate = moment(value as moment.MomentInput);

        return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : '';
    }

  
    public checkAlmacen(): boolean {

        if ( 
            this.model.tipo_transaccion != null &&  
          (this.model.tipo_transaccion === '11' || this.model.tipo_transaccion === '12' ) 
        ) {
            if ( this.model.id_entidad_origen != null && this.model.id_entidad_destino != null ) {
                if ( this.model.ropo_origen != null && this.model.ropo_destino != null ) {
                    if (  
                        (this.model.id_entidad_origen  === this.model.id_entidad_destino )  && 
                      (this.model.ropo_origen  === this.model.ropo_destino ) ) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
        
            return false;
        }

    }

    public checkNIMA(): boolean {
        return (this.model.tipo_transaccion === '9' || this.model.tipo_transaccion === '10') ? true : false;
    }

    public override show(modal: string, data: TransaccionModel): void {
        const modalModel = modal === 'info' || modal === 'delete' ? this.normalizeModalModel(data) : data;

        super.show(modal, modalModel);
        this.setModalForm(modal);
    }// show();

    private normalizeModalModel(data: TransaccionModel): TransaccionModel {
        return {
            ...data,
            importacion_paralela: this.normalizeSwitchValue(data.importacion_paralela),
        } as TransaccionModel;
    }// normalizeModalModel();

    private normalizeSwitchValue(value: unknown): 1 | 0 {
        if (value === 1 || value === true) {
            return 1;
        }// if();

        if (typeof value === 'string') {
            const normalizedValue = value.trim().toLowerCase();

            return ['1', 'true', 'si', 'sí', 's', 'yes'].includes(normalizedValue) ? 1 : 0;
        }// if();

        return 0;
    }// normalizeSwitchValue();

    private setModalForm(modal: string): void {
        if (modal !== 'info' && modal !== 'delete') {
            return;
        }

        const formType = modal === 'delete' ? FormType.DELETION : FormType.INFORMATIVE;

        this.form = new TransaccionesFormDefinition(formType, this.model);
    }

}